import styled, { css } from 'styled-components';
import { dropdownLegendTemplate } from '../../../../../../utils/common.styles';

export const DropdownWrapper = styled.div`
    position: relative;
    width: max-content;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
`;
export const DropdownHeader = styled.div`
    background-color: ${({ theme }) => theme.white.ff};
    ${({ isOpen }) =>
        isOpen
            ? css`
                  z-index: 15;
                  box-shadow: 0px 0px 6px ${({ theme }) => theme.black[29]};
                  border-bottom: 1px solid ${({ theme }) => theme.grey[200]};
              `
            : css`
                  border: 1px solid ${({ theme }) => theme.blue[900]};
              `}

    width: 180px;
    height: 39px;
    cursor: pointer;
    display: flex;
    align-items: center;
    ${dropdownLegendTemplate};
    div {
        display: flex;
        align-items: center;
        margin-left: 14px;
    }

    img {
        right: 17px;
        position: absolute;
    }
`;

export const DropdownMenu = styled.div`
    position: relative;
`;

export const DropdownItemsWrapper = styled.ul`
    position: absolute;
    background-color: ${({ theme }) => theme.white.ff};
    box-shadow: 0px 0px 6px ${({ theme }) => theme.black[29]};
    margin: 0;
    padding: 0;
    z-index: 10;
    list-style: none;
    width: 100%;
    top: 0.5px;
    text-align: left;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const DropdownItem = styled.li`
    ${dropdownLegendTemplate};
    display: flex;
    align-items: center;
    padding-left: 14px;
    height: 35px;
    &:hover {
        background-color: ${({ theme }) => theme.grey[50]};
        cursor: pointer;
    }
`;
